import React from 'react';

import { Caption } from '@depop/web-thrift-ui/Typography';

import { ButtonMinimal } from '@/components/ButtonMinimal';
import { ExtendedLink } from '@/components/ExtendedLink';

type LinkProp = {
  href: string;
  as?: string;
};

/* @johnf 09-11-2023: This is a quick way to create types which can have one of two properties.
 * If we refactor this component we may want to look at cleaner ways of achieving this. */
type TextMenuItemBase = {
  key: string;
  translation: string;
  element?: never;
  disabled?: boolean;
};

type ElementMenuItemBase = {
  key: string;
  translation?: never;
  element: React.ReactNode;
  disabled?: boolean;
};

export interface TextMenuItemLink extends TextMenuItemBase {
  link: LinkProp;
}

export interface TextMenuItemClick extends TextMenuItemBase {
  onClick:
    | ((id: string, key: string) => void)
    | ((event: Event) => void)
    | (() => void | Promise<void>);
}

export interface ElementMenuItemLink extends ElementMenuItemBase {
  link: LinkProp;
}

export interface ElementMenuItemClick extends ElementMenuItemBase {
  onClick: ((id: string, key: string) => void) | (() => void | Promise<void>);
}

type ActionMenuProps = {
  closeActionMenu: () => void;
  handleClick: (
    handler: (id: string, key: string) => void,
    key: string
  ) => void;
  menuItems: Array<
    | TextMenuItemLink
    | TextMenuItemClick
    | ElementMenuItemLink
    | ElementMenuItemClick
  >;
};

function ActionMenuItems({
  menuItems,
  closeActionMenu,
  handleClick,
}: ActionMenuProps) {
  function handleBlur(index: number, size: number) {
    const itemPos = index + 1;
    if (itemPos === size) {
      closeActionMenu();
    }
  }

  return (
    <>
      {menuItems.map((item, index, arr) =>
        'link' in item ? (
          <ExtendedLink
            key={item.key}
            href={item.link.href}
            as={item.link.as}
            onClick={closeActionMenu}
          >
            <Caption
              variant="lg-regular"
              colour="base"
              tabIndex={0}
              role="menuitem"
              // eslint-disable-next-line no-restricted-syntax
              data-testid={`actionMenu__${item.key}Button`}
              onBlur={() => handleBlur(index, arr.length)}
            >
              {item.element || item.translation}
            </Caption>
          </ExtendedLink>
        ) : (
          <ButtonMinimal
            key={item.key}
            role="menuitem"
            tabIndex={0}
            // eslint-disable-next-line no-restricted-syntax
            data-testid={`actionMenu__${item.key}Button`}
            onClick={(event) => {
              const { nativeEvent } = event;
              event.preventDefault();
              event.stopPropagation();
              handleClick((id, key) => {
                if (key === 'nav-logout') {
                  (item.onClick as (event: Event) => void)(nativeEvent);
                } else {
                  (item.onClick as (id: string, key: string) => void)(id, key);
                }
              }, item.key);
            }}
            onBlur={() => handleBlur(index, arr.length)}
            disabled={item?.disabled}
          >
            <Caption variant="lg-regular" colour="base" as="span">
              {item.element || item.translation}
            </Caption>
          </ButtonMinimal>
        )
      )}
    </>
  );
}

export { ActionMenuItems };
